import React, { ReactElement, useEffect, useReducer, useState } from 'react';
import {
  Breadcrumb,
  Button,
  Col,
  Container,
  Divider,
  FlexboxGrid,
  Grid,
  Row,
  Stack,
  Table,
  ButtonToolbar,
  IconButton,
  Panel,
  useToaster,
  Message,
  Modal,
  InputNumber
} from 'rsuite';
import { Icon } from '@rsuite/icons';
import CheckOutlineIcon from '@rsuite/icons/CheckOutline';
const { Column, HeaderCell, Cell, ColumnGroup } = Table;
import useColumns from './columns1';
import { CrudFunctions } from './functions';
import { useLocation, useNavigate } from 'react-router-dom';
import { CostingTableData, ShowTable } from './types';
import axios from 'axios';
import globalIP from '@/GlobelIP';
import MinusIcon from '@rsuite/icons/Minus';
import PlusIcon from '@rsuite/icons/Plus';
import ArrowDownIcon from '@rsuite/icons/ArrowDown';
import { FirstGrid } from './FirstGrid1';
import { PackingSection } from './PackingSection1';
import { BottomLeftSection } from './BottomLeftSection1';
import useCostCalculator1 from './Calculate/CostCalculator1';
import useLabel from '@/clientWeb/hook/Label';
import ugr from '@/UGRoute';
import {
  fetchProductLabel,
} from '../.././apiService/apiService';
import CopyCosting from './CopyCosting';
const reducer = (state, action) => {
  switch (action.type) {
    case 'BuyerData':
      return { ...state, BuyerData: action.payload };
    case 'Process':
      return { ...state, Process: action.payload };
    case 'Material':
      return { ...state, Material: action.payload };
    case 'Currencyrate':
      return { ...state, Currencyrate: action.payload };
    case 'costingId':
      return { ...state, costingId: action.payload };
    case 'reload2':
      return { ...state, reload2: action.payload };
    default:
      return state;
  }
};
export default function CostingPage() {
  const ip = globalIP;

  const location = useLocation();
  const toaster = useToaster();
  const [productData] = useState({
    id: location?.state?.id,
    ...location?.state?.attributes,
    costingFor: location?.state?.costingFor,
    isEdit: location?.state?.isEdit
  });
  // console.log('isEdit');
  // console.log(productData.isEdit);
  const [reFetchBuyerName, setReFetchBuyerName] = useState('');
  const [reload, setReload] = useState(false);
  const [reload2, setReload2] = useState(false);
  const [changeCount, setChangeCount] = useState(0)

  const [state, dispatch] = useReducer(reducer, {
    BuyerData: [],
    Process: [],
    Material: [],
    Currencyrate: {},
    costingId: '',
    reload2: false
  });

  const handleReload = () => {
    if (
      showTables.accessories ||
      showTables.packing ||
      showTables.material ||
      showTables.wood ||
      showTables.process
    ) {
      setReload(prev => !prev);
    } else {
      setReload2(prev => !prev);
    }
  };
  const handleFieldUpdate = (fieldName, value) => {
    // console.log('fieldName', "value");
    // console.log(fieldName, value);
    // Reset the updating state to false for the specific field
    setUpdatingCalc(prevState => ({
      ...prevState,
      [fieldName]: value
    }));
  };
  const { Height, Length, Width, SizeUnit } = productData;
  const maxValue = Math.max(Height, Length, Width, SizeUnit);
  const [open, setOpen] = useState(false);
  const { attributesName } = useLabel();

  const [costingTableData, setCostingTableData] = useState<CostingTableData>({
    CostingMaterial: [],
    CostingWood: [],
    CostingProcess: [],
    CostingAccessory: [],
    Costingpacking: []
  });
  useEffect(() => {
    const fetchData = async (
      endpoint,
      labelAttribute,
      valueAttribute,
      dispatchType,
      includeExtra = null
    ) => {
      try {
        const {
          data: {
            meta: {
              pagination: { pageCount }
            }
          }
        } = await axios.get(`${globalIP}${endpoint}`);
        const requests = [];
        for (let page = 1; page <= pageCount; page++) {
          requests.push(axios.get(`${globalIP}${endpoint}?populate=*&pagination[page]=${page}`));
        }
        const responses = await Promise.all(requests);

        const data = responses
          .flatMap(response => response.data.data)
          .map(item => {
            const attributes = item.attributes;
            const mappedItem = {
              label: attributes[labelAttribute], // Main label
              value: attributes[valueAttribute] // Main value
            };
            if (includeExtra) {
              // Include extra data based on the API type
              mappedItem[includeExtra] = attributes[includeExtra];
            }
            return mappedItem;
          });

        dispatch({ type: dispatchType, payload: data });
      } catch (error) {
        console.error(`Error fetching data for ${dispatchType}:`, error);
      }
    };

    const GetCurrenyRate = async () => {
      try {
        const { data } = await axios.get(
          `${globalIP}/api/currency-masters?populate=*&filters[currencyname][$eq]=USD`
        );
        dispatch({
          type: 'Currencyrate',
          payload: { id: data.data[0]['id'], ...data.data[0]['attributes'] }
        });
      } catch (error) {
        console.error('Error fetching currency rate:', error);
      }
    };
    // Fetch Data for APIs
    fetchData('/api/buyer-details', 'buyernm', 'buyernm', 'BuyerData');
    // fetchData('/api/mst-ptechniques', 'Process', 'Process', 'Process');
    fetchData('/api/mstmaterials', 'MaterialName', 'MaterialName', 'Material', 'Type'); // Include Type
    // fetchData('/api/mstprocesses', 'Process', 'Process', 'Process', 'Price',); // Include Price
    GetCurrenyRate();
  }, [location.state]);

  useEffect(() => {

  }, [location.state]);
  useEffect(() => {
    const fetchProcessesOnMaterials = async () => {
      try {
        // Fetch all materials (for chiefMaterial and chiefWood)
        const materialResponses = await axios.get(`${globalIP}/api/mstmaterials?populate=*`);
        const materialData = materialResponses.data.data;

        // Find material types for chiefMaterials
        const chiefMaterialTypes = costingTableData.CostingMaterial.map(item => {
          const material = materialData.find(
            mat => mat.attributes.MaterialName === item.chiefmaterial
          );
          return material ? material.attributes.Type : null;
        }).filter(type => type !== null);

        // console.log('Chief Material Types:', chiefMaterialTypes);

        // Find material types for chiefWood
        const chiefWoodTypes = costingTableData.CostingWood.map(item => {
          const woodMaterial = materialData.find(
            mat => mat.attributes.MaterialName === item.woodmaterial
          );
          return woodMaterial ? woodMaterial.attributes.Type : null;
        }).filter(type => type !== null);

        // console.log('Chief Wood Types:', chiefWoodTypes);

        // Combine both material and wood types for process fetching
        const allTypes = [...chiefMaterialTypes, ...chiefWoodTypes]; // Remove duplicates

        // console.log('All Types for Filtering Processes:', allTypes);

        // Fetch mstprocesses filtered by all types
        const processRequests = allTypes.map(type =>
          axios.get(`${globalIP}/api/mstprocesses?populate=*&filters[Type][$eq]=${type}`)
        );

        const processResponses = await Promise.all(processRequests);
        const processes = processResponses.flatMap(response => response.data.data);

        const processData = processes
          .map(item => ({
            label: item.attributes.Process,
            value: item.attributes.Process,
            Price: item.attributes.Price,
            Type: item.attributes.Type,
            uom: item.attributes.uom
          }))
          .reduce((uniqueItems, currentItem) => {
            // Check if the label-value pair is already in the uniqueItems array
            const exists = uniqueItems.some(item => item.label === currentItem.label && item.value === currentItem.value);
            if (!exists) {
              uniqueItems.push(currentItem);
            }
            return uniqueItems;
          }, []);

        dispatch({ type: 'Process', payload: processData });

      } catch (error) {
        console.error('Error fetching processes based on materials and wood:', error);
      }
    };
    fetchProcessesOnMaterials();
  }, [costingTableData.CostingMaterial.length, costingTableData.CostingWood.length]);

  const notify = (message, placement?, type?) => {
    toaster.push(
      <Message showIcon type={type || 'error'}>
        {message}
      </Message>,
      { placement: placement || 'topEnd' }
    );
  };
  const [orgcostingTableData, setorgCostingTableData] = useState<CostingTableData>({
    CostingMaterial: [],
    CostingWood: [],
    CostingProcess: [],
    CostingAccessory: [],
    Costingpacking: []
  });

  const [updatingCalc, setUpdatingCalc] = useState({
    TargetCost: false,
    Testingper: false,
    Testingcost: false,
    GST: false,
    Miscper: false,
    Misccost: false,
    OverHeadper: false,
    OverHeadcost: false,
    Otherper: false,
    Othercost: false,
    Laisonper: false,
    Laisoncost: false,
    Accessories: false,
    Packing: false,
    NetWeight: false,
    RateperKg: false,
    Size: false,
    Rateperinch: false,
    Fitting: false,
    Polish: false,
    InnerCost: false,
    MasterCost: false,
    Shipping: false,
    Profitper: false
  });
  const [label, setLabel] = useState([]);
  useEffect(() => {
    fetchProductLabel(setLabel);
  }, []);
  const [updatingLaisonCost, setUpdatingLaisonCost] = useState(false);
  const [fieldData, setFieldData] = useState({
    ProductId: String(productData?.id),
    prdcd: productData?.ProductCode,
    costingfor: productData.costingFor.for == 'buyer' ? 'buyer' : 'factory',
    buyername: '',
    costingtype: 'Draff',
    targetCost: 0,
    Netwgt: 0,
    perkgrate: 0,
    itemcost: 0,
    size: 0,
    rate: 0,
    finishcost: 0,
    accessorycost: 0,
    fittingcost: 0,
    packingcost: 0,
    innercost: 0,
    mastercost: 0,
    shippingcost: 0,
    gstper: 0,
    gstcost: 0,
    testingper: 0,
    testingcost: 0,
    laisonper: 0,
    laisoncost: 0,
    otherper: 0,
    othercost: 0,
    overheadper: 0,
    overheadcost: 0,
    miscper: 0,
    misccost: 0,
    subtotalcost: 0,
    subtotalwohcost: 0,
    totalinr: 0,
    profitper: 0,
    profitcost: 0,
    targetcostUSD: 0,
    costingtypRev: 0,
    currencyRate: 0,
    overallcost: 0,
    Fortyfeet: 0,
    TwentyFeet: 0,
    CbmPcs: 0,
    CartnCBM: 0
  });
  useEffect(() => {
    // console.log('updatingCalc');
    // console.log(updatingCalc);
  }, [updatingCalc]);
  const [showTables, setShowTables] = useState<ShowTable>({
    material: false,
    wood: false,
    process: false,
    accessories: false,
    packing: false
  });
  useEffect(() => {
    if (productData.costingFor.for == 'buyer') {
      setFieldData(prev => ({
        ...prev,
        buyername: productData.costingFor.name,
        costingfor: 'buyer'
      }));
    } else if (productData.costingFor.for == 'factory') {
      setFieldData(prev => ({ ...prev, buyername: '', costingfor: 'factory' }));
    }
  }, [location.state, productData]);
  useEffect(() => {
    const setExistAllData = async buyername => {
      const {
        data: { data }
      } = await axios.get(
        `${globalIP}/api/costings?populate=*&filters[ProductId][$eq]=${productData.id
        }&filters[prdcd][$eq]=${productData.ProductCode}&filters[buyername][$eq]=${buyername ? buyername : productData.costingFor.name
        }`
      );
      if (!data.length) {
        const {
          data: { data }
        } = await axios.get(
          `${globalIP}/api/costings?populate=*&filters[ProductId][$eq]=${productData.id}&filters[prdcd][$eq]=${productData.ProductCode}&filters[buyername][$eq]=`
        );
        const {
          CostingAccessory,
          CostingMaterial,
          CostingProcess,
          CostingWood,
          Costingpacking,
          ...remainingData
        } = data[0]?.attributes;
        setTotalCBMperpc(data[0]?.attributes.CbmPcs);
        setTotalCBM(data[0]?.attributes.CartnCBM);
        setFeet40(data[0]?.attributes.Fortyfeet);
        setFeet20(data[0]?.attributesTwentyFeet);
        const tableData = {
          CostingAccessory,
          CostingMaterial,
          CostingProcess,
          CostingWood,
          Costingpacking
        };
        setShowTables(prev => ({
          ...prev,
          accessories: CostingAccessory.length ? true : false,
          material: CostingMaterial.length ? true : false,
          process: CostingProcess.length ? true : false,
          wood: CostingWood.length ? true : false,
          packing: Costingpacking.length ? true : false
        }));
        if (
          !CostingAccessory.length ||
          !CostingMaterial.length ||
          !CostingProcess.length ||
          !CostingWood.length ||
          !Costingpacking.length
        ) {
          dispatch({ type: 'reload2', payload: !state.reload2 });
        }
        setFieldData({
          ...remainingData,
          buyername:
            remainingData.buyername || fieldData.buyername || location.state.costingFor.name
        });
        setorgCostingTableData(tableData);
        setCostingTableData(tableData);
        if (remainingData.Netwgt && remainingData.perkgrate) {
          calculateMultiplication('itemcost', remainingData.Netwgt, remainingData.perkgrate);
        }
        dispatch({ type: 'costingId', payload: data[0].id });
        return;
      }

      const {
        CostingAccessory,
        CostingMaterial,
        CostingProcess,
        CostingWood,
        Costingpacking,
        ...remainingData
      } = data[0]?.attributes;
      const tableData = {
        CostingAccessory,
        CostingMaterial,
        CostingProcess,
        CostingWood,
        Costingpacking
      };
      setShowTables(prev => ({
        ...prev,
        accessories: CostingAccessory.length ? true : false,
        material: CostingMaterial.length ? true : false,
        process: CostingProcess.length ? true : false,
        wood: CostingWood.length ? true : false,
        packing: Costingpacking.length ? true : false
      }));
      if (
        !CostingAccessory.length ||
        !CostingMaterial.length ||
        !CostingProcess.length ||
        !CostingWood.length ||
        !Costingpacking.length
      ) {
        dispatch({ type: 'reload2', payload: !state.reload2 });
      }
      
      setFieldData({
        ...remainingData,
        buyername: remainingData.buyername || location.state.costingFor.name || ''
      });
      setorgCostingTableData(tableData);
      setCostingTableData(tableData);
      if (remainingData.Netwgt && remainingData.perkgrate) {
        calculateMultiplication('itemcost', remainingData.Netwgt, remainingData.perkgrate);
      }
      dispatch({ type: 'costingId', payload: data[0].id });
    };

    const handleRevionData = async () => {
      const {
        data: { data }
      } = await axios.get(
        `${globalIP}/api/costing-histories/${location?.state?.revisionId}?populate=*`
      );
      const {
        CostingAccessory_his: CostingAccessory,
        CostingMaterial_his: CostingMaterial,
        CostingProcess_his: CostingProcess,
        CostingWood_his: CostingWood,
        Costingpacking_his: Costingpacking,
        ...remainingData
      } = data.attributes;
      const tableData = {
        CostingAccessory,
        CostingMaterial,
        CostingProcess,
        CostingWood,
        Costingpacking
      };
     
      setShowTables(prev => ({
        ...prev,
        accessories: CostingAccessory.length ? true : false,
        material: CostingMaterial.length ? true : false,
        process: CostingProcess.length ? true : false,
        wood: CostingWood.length ? true : false,
        packing: Costingpacking.length ? true : false
      }));
      if (
        !CostingAccessory.length ||
        !CostingMaterial.length ||
        !CostingProcess.length ||
        !CostingWood.length ||
        !Costingpacking.length
      ) {
        dispatch({ type: 'reload2', payload: !state.reload2 });
      }
      setFieldData({
        ...remainingData,
        buyername: remainingData.buyername || location.state.costingFor.name || ''
      });
      setorgCostingTableData(tableData);
      setCostingTableData(tableData);
      if (remainingData.Netwgt && remainingData.perkgrate) {
        calculateMultiplication('itemcost', remainingData.Netwgt, remainingData.perkgrate);
      }
      dispatch({ type: 'costingId', payload: data.id });
    };
    if (!location?.state?.fetchRevision) {
      setExistAllData(fieldData.buyername);
    } else {
      handleRevionData();
    }
  }, [location.state, productData, reFetchBuyerName]);


  const [selectedcurr, setSelectedCurr] = useState();
  const [currencydata, setCurrencydata] = useState([]);
  const { handleAddRow, handleDeleteRow, handleChange } = CrudFunctions(
    setCostingTableData,
    setReload,
    maxValue,
    productData
  );
  const handleFieldDataValue = (key, value) => {

    setFieldData(prev => ({
      ...prev,
      [key]: value
    }));
  };


  function calculateMultiplication(fieldName, first, second) {
    if (first && second) {
      const multiply = Number(first) * Number(second);
      setFieldData(prev => ({
        ...prev,
        [fieldName]: multiply
      }));
    }
    setReload2(prev => !prev);
  }

  const [totalInnerPc, setTotalInnerPc] = useState(0);
  const [totalMasterPC, setTotalMasterPC] = useState(0);

  useEffect(() => {
    if (productData?.Packaging) {
      const innerTotal = productData.Packaging.filter(item => item?.CartonType === 'inner')
        .reduce((accumulator, item) => accumulator + item.Carton_PCS, 0);
      const masterTotal = productData.Packaging.filter(item => item?.CartonType === 'master')
        .reduce((accumulator, item) => accumulator + item.Carton_PCS, 0);
      setTotalInnerPc(innerTotal);
      setTotalMasterPC(masterTotal);
    }
  }, [productData])
  useEffect(() => {
    // console.log('totalMasterPC',totalMasterPC);
  }, [totalMasterPC]);
  const [totalCBMperpc, setTotalCBMperpc] = useState(
    productData?.Packaging?.filter(item => item?.CartonType == 'master')
      .reduce((accumulator, item) => accumulator + item.Carton_CBMperpc, 0)
      .toFixed(4)
  );

  const [totalCBM, setTotalCBM] = useState(
    productData?.Packaging?.filter(item => item?.CartonType == 'master')
      .reduce((accumulator, item) => accumulator + item.Carton_CBM, 0)
      .toFixed(4)
  );
  const [feet20, setFeet20] = useState(0);
  const [feet40, setFeet40] = useState(0);
  useEffect(() => {
    if (Number(totalCBM) == 0) {
      setFeet20(0);
      setFeet40(0);
    } else {
      setFeet20(Math.round(27 / totalCBM) * totalMasterPC);
      setFeet40(Math.round(65 / totalCBM) * totalMasterPC);
    }
  }, [totalCBM, totalMasterPC]);
  useEffect(() => {
    if (productData?.ProductionDetail?.length) {
      // Filter details for 'wmaterial' type
      const wMaterialDetails = productData.ProductionDetail.filter(detail =>
        state?.Material?.some(item => (item.Type === 'wmaterial' || item.Type === 'mrmaterial') && item.value === detail.MaterialNm)
      );

      // Filter details for 'cmaterial' type
      const cMaterialDetails = productData.ProductionDetail.filter(detail =>
        state?.Material?.some(item => item.Type === 'cmaterial' && item.value === detail.MaterialNm)
      );


      // Set the visibility of sections based on counts
      setShowTables(prevState => ({
        ...prevState, // Keep all previous values
        material: cMaterialDetails.length > 0, // Show only if there are 'cmaterial' rows
        wood: wMaterialDetails.length > 0, // Update wood status
        process: wMaterialDetails.length > 0 || cMaterialDetails.length > 0
      }));
    }
  }, [productData?.ProductionDetail, state?.Material]);

  const handleToggle = key => {
    setShowTables(prev => ({ ...prev, [key]: !prev[key] }));

    const tableNames = {
      material: 'CostingMaterial',
      wood: 'CostingWood',
      process: 'CostingProcess',
      accessories: 'CostingAccessory',
      packing: 'Costingpacking'
    };

    if (tableNames[key]) {
      const tableName = tableNames[key];

      if (showTables[key]) {
        // If section is already open, clear the data on toggle off
        setCostingTableData(prev => ({ ...prev, [tableName]: [] }));
      } else {
        // If section is toggled on
        if (key === 'material' && productData?.ProductionDetail?.length > 0) {
          // Reload rows from ProductionDetail
          const updatedCostingMaterial = productData.ProductionDetail.filter(detail =>
            state?.Material?.some(
              item => item.Type === 'cmaterial' && item.value === detail.MaterialNm
            )
          ).map(detail => ({
            chiefmaterial: detail.MaterialNm, // Set the MaterialNm from ProductionDetail
            unit: 'Kg', // Default or derive from detail if available
            wgtqty: detail.Qty || 0, // Default weight/qty
            materialrate: 0, // Default rate
            batta: 0, // Default batta
            totalmaterialcost: 0 // Initial total cost
          }));
          setCostingTableData(prev => ({ ...prev, [tableName]: updatedCostingMaterial }));
        } else if (key === 'wood' && productData?.ProductionDetail?.length > 0) {
          // Reload rows from ProductionDetail
          const updatedCostingWood = productData.ProductionDetail.filter(detail =>
            state?.Material?.some(
              item => (item.Type === 'wmaterial' || item.Type === 'mrmaterial') && item.value === detail.MaterialNm
            )
          ).map(detail => ({
            woodmaterial: detail.MaterialNm, // Fetch MaterialNm from filtered ProductionDetail
            component: detail.Component, // Default value for component
            quantity: detail.MatNetWeight || 0, // Default weight/quantity
            rate: 0, // Default rate
            totalcost: 0 // Initial total cost
          }));
          setCostingTableData(prev => ({ ...prev, [tableName]: updatedCostingWood }));
        } else {
          // For other cases, add an empty row
          handleAddRow(tableName);
        }
      }
    }
  };

  const [packaging, setPackaging] = useState([]);
  const [cartoonSize, setCartoonSize] = useState([]);
  const [reset, setReset] = useState(false);

  const navigate = useNavigate();
  const handleReset = async () => {
    const { data } = await axios.delete(
      `${globalIP}/api/costings/${state.costingId}?populate=*`,
    );
    const res = await axios.get(
      `${globalIP}/api/costing-histories?filters[ProductId]=${fieldData.ProductId}`,
    );
    const histories = res.data.data;
    if (histories.length > 0) {
      histories.forEach(async (item) => {
        const { data } = await axios.delete(
          `${globalIP}/api/costing-histories/${item.id}?populate=*`,
        );
      });
    }
    setTimeout(() => {
      navigate(`/${ugr}/product-Selection-Page`);
    }, 500);
  }
  const handleDataSave = async () => {
    const packaginDetails = {
      Fortyfeet: fieldData.Fortyfeet ? fieldData.Fortyfeet : feet40,
      TwentyFeet: fieldData.TwentyFeet ? fieldData.TwentyFeet : feet20,
      CbmPcs: fieldData.CbmPcs ? fieldData.CbmPcs : totalCBMperpc,
      CartnCBM: fieldData.CartnCBM ? fieldData.CartnCBM : totalCBM
    };
    const { CartonSize, ...otherfielddata } = fieldData
    let NewData = {
      ...otherfielddata,
      ...costingTableData,
      ...packaginDetails
    };
    // console.log('fieldData', fieldData);
    // console.log('costingTableData', costingTableData);
    // return;
    if (!fieldData.costingtype) {
      notify('Select Costing Type');
      return;
    } else if (!fieldData.targetCost) {
      notify('Fill Target Cost');
      return;
    }
    if (productData.costingFor.for == 'buyer') {
      if (!fieldData.buyername) {
        notify('Select BuyerName');
        return;
      }
    }
    const getData = await axios.get(`${globalIP}/api/costings/${state.costingId}?populate=*`);
    // return;
    if (location.state.costingFor.for == 'buyer' && fieldData.costingfor == 'factory') {
      const { data } = await axios.post(`${globalIP}/api/costings?populate=*`, {
        data: { ...NewData, costingtypRev: 1, costingfor: 'buyer' }
      });
      setOpen(true);
    } else {
      if (fieldData.costingtype == 'Draff') {
        if (getData.data.data.attributes) {
          if (getData.data.data.attributes.costingtype == 'Revision') {
            const { data } = await axios.put(
              `${globalIP}/api/costings/${state.costingId}?populate=*`,
              {
                data: { ...NewData, costingtypRev: 1 }
              }
            );
            setOpen(true);
          } else if (getData.data.data.attributes.costingtype == 'Draff') {
            const { data } = await axios.put(
              `${globalIP}/api/costings/${state.costingId}?populate=*`,
              {
                data: { ...NewData, costingtypRev: getData.data.data.attributes.costingtypRev + 1 }
              }
            );
            setOpen(true);
          }
        } else {
          const { data } = await axios.post(`${globalIP}/api/costings?populate=*`, {
            data: { ...NewData, costingtypRev: 1 }
          });
          setOpen(true);
        }
      } else {
        if (getData.data.data.attributes) {
          if (getData.data.data.attributes.costingtype == 'Draff') {
            NewData = {
              ...fieldData,
              ...costingTableData,
              costingtypRev: 1
            };
            const { data } = await axios.put(
              `${globalIP}/api/costings/${state.costingId}?populate=*`,
              {
                data: NewData
              }
            );
          } else if (getData.data.data.attributes.costingtype == 'Revision') {
            NewData = {
              ...fieldData,
              ...costingTableData,
              costingtypRev: getData.data.data.attributes.costingtypRev + 1
            };
            const { data } = await axios.put(
              `${globalIP}/api/costings/${state.costingId}?populate=*`,
              {
                data: NewData
              }
            );
          }
        } else {
          const { data } = await axios.post(`${globalIP}/api/costings?populate=*`, {
            data: { ...NewData, costingtypRev: 1 }
          });
          setOpen(true);
        }

        const historyData = {
          ...fieldData,
          TwentyFeetHis: getData?.data?.data?.attributes?.TwentyFeet,
          FortyfeetHis: getData?.data?.data?.attributes?.Fortyfeet,
          CbmPcsHis: getData?.data?.data?.attributes?.CbmPcs,
          CartnCBMHis: getData?.data?.data?.attributes?.CartnCBM,
          CatronSize_his: getData?.data?.data?.attributes?.CartonSize,
          CostingMaterial_his: costingTableData.CostingMaterial,
          CostingWood_his: costingTableData.CostingWood,
          CostingProcess_his: costingTableData.CostingProcess,
          CostingAccessory_his: costingTableData.CostingAccessory,
          Costingpacking_his: costingTableData.Costingpacking
        };
        if (productData.costingFor.for == 'buyer' && fieldData.costingtype == 'Revision') {
          const {
            data: { data, meta }
          } = await axios.get(
            `${globalIP}/api/costing-histories?populate=*&filters[ProductId][$eq]=${productData.id
            }&filters[prdcd][$eq]=${productData.ProductCode}&filters[buyername][$eq]=${fieldData.buyername ? fieldData.buyername : productData.costingFor.name
            }`
          );
          const lastPageData = await axios.get(
            `${globalIP}/api/costing-histories?populate=*&filters[ProductId][$eq]=${productData.id
            }&filters[prdcd][$eq]=${productData.ProductCode}&filters[buyername][$eq]=${fieldData.buyername ? fieldData.buyername : productData.costingFor.name
            }&pagination[page]=${meta.pagination.pageCount}`
          );
          if (data.length) {
            const historyDataSave = await axios.post(
              `${globalIP}/api/costing-histories?populate=*`,
              {
                data: {
                  ...historyData,
                  RevisionNo: String(+lastPageData.data.data.at(-1).attributes.RevisionNo + 1)
                }
              }
            );
            if (historyDataSave.data.data.attributes) {
              setOpen(true);
            }
          } else {
            const historyDataSave = await axios.post(
              `${globalIP}/api/costing-histories?populate=*`,
              { data: { ...historyData, RevisionNo: String(1) } }
            );
            if (historyDataSave.data.data.attributes) {
              setOpen(true);
            }
          }
        } else if (productData.costingFor.for == 'factory' && fieldData.costingtype == 'Revision') {
          const {
            data: { data, meta }
          } = await axios.get(
            `${globalIP}/api/costing-histories?populate=*&filters[ProductId][$eq]=${productData.id}&filters[prdcd][$eq]=${productData.ProductCode}&filters[buyername][$eq]=`
          );
          const lastPageData = await axios.get(
            `${globalIP}/api/costing-histories?populate=*&filters[ProductId][$eq]=${productData.id}&filters[prdcd][$eq]=${productData.ProductCode}&filters[buyername][$eq]=&pagination[page]=${meta.pagination.pageCount}`
          );
          if (data.length) {
            const historyDataSave = await axios.post(
              `${globalIP}/api/costing-histories?populate=*`,
              {
                data: {
                  ...historyData,
                  RevisionNo: String(+lastPageData.data.data.at(-1).attributes.RevisionNo + 1)
                }
              }
            );
            if (historyDataSave.data.data.attributes) {
              setOpen(true);
            }
          } else {
            const historyDataSave = await axios.post(
              `${globalIP}/api/costing-histories?populate=*`,
              { data: { ...historyData, RevisionNo: String(1) } }
            );
            if (historyDataSave.data.data.attributes) {
              setOpen(true);
            }
          }
        }
      }
    }
    // if (costingTableData?.CostingMaterial?.length) {
    //   // Directly map CostingMaterial into ProductionDetail
    //   const updatedProductionDetail = productData?.ProductionDetail?.map((detail, index) => {
    //     // Get the corresponding CostingMaterial by index
    //     const material = costingTableData.CostingMaterial[index];
    //     if (material) {
    //       console.log('Assigning material to ProductionDetail:', material);
    //       return {
    //         ...detail,
    //         MaterialNm: material.chiefmaterial // Directly assign 'chiefmaterial'
    //       };
    //     }
    //     return detail; // If no matching material, return the detail unchanged
    //   });
    //   console.log('Updated ProductionDetail:', updatedProductionDetail);
    //   if (updatedProductionDetail) {
    //     try {
    //       // Send updated ProductionDetail to the API
    //       await axios.put(`${globalIP}/api/products/${productData.id}`, {
    //         data: {
    //           ProductionDetail: updatedProductionDetail
    //         }
    //       });
    //       notify('Production Detail updated successfully', 'TopEnd', 'success');
    //     } catch (error) {
    //       console.error('Error updating ProductionDetail:', error);
    //       notify('Failed to update Production Detail');
    //     }
    //   } else {
    //     notify('No changes to Production Detail.');
    //   }
    // }

    try {
      const req = await fetch(
        `${globalIP}/api/costings?populate=*&sort[0]=id:desc&filters[prdcd]=${fieldData.prdcd}`
      );
      const res = await req.json();
      let newPack = packaging
        // .filter(item => item.CartonType === 'master')
        .map(item => {
          return {
            Height: item.Carton_Thick,
            Length: item.Carton_Length,
            Width: item.Carton_Width,
            Unit: item.Carton_Unit,
            Pcs: item.Carton_PCS,
            Type:item.CartonType

          };
        });

      if (newPack.length > 0) {
        const response = await axios.put(`${ip}/api/costings/${res.data[0].id}`, {
          data: {
            CartonSize: newPack,
            Fortyfeet: fieldData.Fortyfeet ? fieldData.Fortyfeet : feet40,
            TwentyFeet: fieldData.TwentyFeet ? fieldData.TwentyFeet : feet20,
            CbmPcs: fieldData.CbmPcs ? fieldData.CbmPcs : totalCBMperpc,
            CartnCBM: fieldData.CartnCBM ? fieldData.CartnCBM : totalCBM
          }
        });
      }

    } catch (error) {
      console.error('Error updating packaging:', error);
    }
    if (fieldData.ProductId) {
      const response = await axios.put(`${ip}/api/products/${fieldData.ProductId}`, {
        data: {
          "SellingPriceCurrency": selectedcurr?.label,
          "SellingPriceUnit": `${fieldData?.currencyRate}`,
          "SellingPrice": fieldData?.targetcostUSD,
          "ProductCost": fieldData.targetCost,
        }
      });
    }
    setOpen(true); // Final UI update
  };

  const buttons = [
    { key: 'material', text: 'Add Material' },
    { key: 'wood', text: 'Add Wood' },
    { key: 'process', text: 'Add Process' },
    { key: 'accessories', text: 'Add Accessories' },
    { key: 'packing', text: 'Add Packing' }
  ];

  if (!productData && !state.BuyerData.length) {
    return;
  }
  const [selectedCosting, setSelectedCosting] = useState();
  const [btnshow, setBtnshow] = useState(false);
  const [costingheads, setCostingheads] = useState({});
  const costing = useCostCalculator1(
    cartoonSize,
    costingheads,
    totalMasterPC,
    updatingCalc,
    fieldData,
    setFieldData,
    reload,
    reload2,
    costingTableData,
    showTables,
    state,
    totalCBMperpc,
    changeCount
  );

  const [materialData, setMaterialData] = useState([]);

  useEffect(() => {
    const fetchAllMaterialData = async () => {
      try {
        let allMaterials = [];
  
        // Fetch the first page to get pagination info
        const firstResponse = await axios.get(`${globalIP}/api/mstmaterials?&pagination[page]=1`);
        const firstPageData = firstResponse.data.data;
        const pageCount = firstResponse.data.meta.pagination.pageCount;
  
        allMaterials = [...firstPageData];
  
        // Fetch remaining pages if more than 1 page
        const pageRequests = [];
  
        for (let page = 2; page <= pageCount; page++) {
          pageRequests.push(
            axios.get(`${globalIP}/api/mstmaterials?&pagination[page]=${page}`)
          );
        }
  
        const responses = await Promise.all(pageRequests);
        responses.forEach((res) => {
          allMaterials = [...allMaterials, ...res.data.data];
        });
  
        setMaterialData(allMaterials);
      } catch (error) {
        console.error("Error fetching all material data:", error);
      }
    };
  
    fetchAllMaterialData();
  }, []);
  const [latest, setlatest] = useState(false)
  const fetchLatestDetails = async () => {
    try {
      const response = await axios.get(`${ip}/api/products/${fieldData.ProductId}?populate=*`);
      const productionDetails = response.data.data.attributes?.ProductionDetail || [];


      if (productionDetails.length && materialData) {
        // Precompute the material lookup for fast access
        const materialMap = materialData.reduce((acc, mat) => {
          const { MaterialName, Type, Cost, uom, batta } = mat.attributes;
          if (Type === 'cmaterial' || Type === 'wmaterial' || Type === 'mrmaterial') {
            acc[MaterialName] = { Cost, uom, batta, MaterialName, Type };
          }
          return acc;
        }, {});

        // Process CostingMaterial in one loop
        const updatedCostingMaterial = productionDetails
          .filter((detail) =>
            state?.Material?.some((item) => item.Type === 'cmaterial' && item.value === detail.MaterialNm)
          )
          .map((detail) => {
            const matchedMaterial = materialMap[detail.MaterialNm] || {};
            const { uom, Cost = 0, batta = 0 } = matchedMaterial;

            return {
              chiefmaterial: detail.MaterialNm,
              unit: uom || "kg",
              wgtqty: (uom === 'kg' || !uom) ? detail.MatNetWeight : detail.Qty || 0,
              materialrate: Cost,
              batta,
              totalmaterialcost: detail.MatNetWeight * Cost || 0,
            };
          });

        // Only update if the result is different
        if (updatedCostingMaterial.length) {
          handleChange('CostingMaterial', updatedCostingMaterial, 'init', 0);
          handleChange('CostingMaterial', updatedCostingMaterial[0]?.wgtqty, 'wgtqty', 0);

          // Update fieldData and reload state in one go
          setFieldData((prev) => ({
            ...prev,
            Netwgt: 0
          }));
          setReload((prev) => !prev);
        }

        // Process CostingWood in one loop
        const updatedCostingWood = productionDetails
          .filter((detail) =>
            state?.Material?.some((item) => ['wmaterial', 'mrmaterial'].includes(item.Type) && item.value === detail.MaterialNm)
          )
          .map((detail) => {
            const matchedMaterial = materialMap[detail.MaterialNm] || {};
            const { Cost = 0 } = matchedMaterial;
            return {
              woodmaterial: detail.MaterialNm,
              component: detail.Component || '',
              Unit: matchedMaterial?.uom,
              quantity: detail.MatNetWeight || 0,
              F_L: detail.Length,
              F_W: detail.Width,
              F_T: detail.Height,
              PCS: detail.Qty, // Default pcs
              F_Unit: detail.Unit === 'cm' ? 'Cm' : 'Inch',
              R_Unit: 'Inch',
              woodrate: Cost,
            };
          });

        // Only update if the result is different
        if (updatedCostingWood.length) {
          handleChange('CostingWood', updatedCostingWood, 'init', 0);
          setReload((prev) => !prev);
        }

        setlatest(true);  // Update after all changes to avoid redundant re-renders

      }
    } catch (error) {
      console.error('Error fetching details:', error);
    }
  };

  const fetchLatestcostingHeads = async () => {
    await axios
      .get(`${globalIP}/api/costingheads?populate=*`)
      .then(response => {
        const fetchedData = response.data.data[0].attributes;
        // Set initial values based on the fetched API data
        // console.log('fetchedData', fetchedData);
        handleFieldDataValue('profitper', fetchedData.Profit);
        handleFieldDataValue('gstper', fetchedData.gst);
        handleFieldDataValue('laisonper', fetchedData.laison);
        handleFieldDataValue('otherper', fetchedData.other);
        handleFieldDataValue('testingper', fetchedData.testing);
        handleFieldDataValue('overheadper', fetchedData.overhead);
        handleFieldDataValue('miscper', fetchedData.misc);
        setCostingheads(fetchedData);
        handleReload();

      })

      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }
  useEffect(() => {
    axios
      .get(`${globalIP}/api/costingheads?populate=*`)
      .then(response => {
        const fetchedData = response.data.data[0].attributes;
        // Set initial values based on the fetched API data
        // console.log('fetchedData', fetchedData);
        handleFieldDataValue('profitper', fetchedData.Profit);
        handleFieldDataValue('gstper', fetchedData.gst);
        handleFieldDataValue('laisonper', fetchedData.laison);
        handleFieldDataValue('otherper', fetchedData.other);
        handleFieldDataValue('testingper', fetchedData.testing);
        handleFieldDataValue('overheadper', fetchedData.overhead);
        handleFieldDataValue('miscper', fetchedData.misc);
        setCostingheads(fetchedData);
      })

      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }, []); // Empty dependency array means this effect runs only once when the component mounts

  const { columns, columns1, columns2, columns3, columns4 } = useColumns(
    handleChange,
    costingTableData,
    handleDeleteRow,
    state,
    setFieldData,
    setReload,
    productData,
    fieldData,
    setlatest,
    latest,
    changeCount,
    setChangeCount
  );

  return (
    <>
      <Container className="main">
        <Stack
          className="table-toolbar"
          style={{
            width: " -webkit-fill-available",
            position: 'fixed',
            height: '120px',
            background: ' rgb(255, 255, 255)',
            zIndex: 9,
            boxShadow: "2px 2px #ebebeb"
          }}
          justifyContent="space-between"
        >
          <Stack direction="column" alignItems="flex-start"

          >
            <h3 className="title">Manage Costing</h3>
            <Breadcrumb>
              <Breadcrumb.Item href={`/${ugr}/dashboard`}>Home</Breadcrumb.Item>
              <Breadcrumb.Item href={`/${ugr}/products`}>Products</Breadcrumb.Item>
              <Breadcrumb.Item href={`/${ugr}/product-Selection-Page`}>
                Costing Insertion
              </Breadcrumb.Item>
              {location?.state?.revisionId && (
                <Breadcrumb.Item href={`/${ugr}/costing-view`}>Costing View</Breadcrumb.Item>
              )}
              <Breadcrumb.Item active>Costing</Breadcrumb.Item>
            </Breadcrumb>
          </Stack>
          <Stack direction="row" spacing={10} alignItems="flex-end">
            {btnshow && (
              <ButtonToolbar>
                {buttons.map(({ key, text }) => (
                  <IconButton
                    key={key}
                    size="sm"
                    style={{ fontSize: '13px' }}
                    icon={!showTables[key] ? <PlusIcon /> : <MinusIcon />}
                    onClick={() => handleToggle(key)}
                  >
                    {text}
                  </IconButton>
                ))}
              </ButtonToolbar>
            )}
            {!fieldData.updatedAt &&
              <CopyCosting
                fieldData={fieldData}
                setFieldData={setFieldData}
                setShowTables={setShowTables}
                setCostingTableData={setCostingTableData}
                btnshow={btnshow}
                selectedCosting={selectedCosting}
                setSelectedCosting={setSelectedCosting}
              />}
            <Button
              appearance="primary"
              color="cyan"
              size="sm"
              onClick={() => {
                if (!latest) {
                  fetchLatestcostingHeads()
                  fetchLatestDetails()
                }
              }
              }
            >
              Update Costing Heads
            </Button>
            <Button
              appearance="primary"
              color="cyan"
              size="sm"
              onClick={() => setBtnshow(!btnshow)}
            >
              Details
            </Button>
            {productData.isEdit && (
              <Button
                size="sm"
                color="cyan"
                appearance="primary"
                style={{ fontSize: '13px' }}
                onClick={() => handleDataSave()}
              >
                Save
              </Button>
            )}
            {productData.isEdit && (
              <Button
                appearance="primary"
                color="cyan"
                size="sm"
                onClick={() => setReset(true)}
              >
                Delete Costing
              </Button>
            )}
            {location?.state?.revisionId ? (
              <p>Revision {+location.state.revisionData.RevisionNo}</p>
            ) : null}
          </Stack>
        </Stack>
        <Divider style={{ margin: '0px 0 10px 0' }} />
      </Container>
      <main style={{ marginTop: "130px", padding: '0 20px', marginBottom: '10px' }}>
        <Grid fluid>
          <Row>
            <Col xs={24} style={{ marginBottom: '16px' }}>
              <Row style={{ paddingLeft: '20px' }}>
                <Col xs={17}>
                  <FirstGrid
                    handleAddRow={handleAddRow}
                    updatingCalc={updatingCalc}
                    setUpdatingCalc={setUpdatingCalc}
                    handleFieldUpdate={handleFieldUpdate}
                    costingTableData={costingTableData}
                    columns={columns}
                    state={state}
                    buyerData={state?.BuyerData}
                    calculateMultiplication={calculateMultiplication}
                    handleFieldDataValue={handleFieldDataValue}
                    fieldData={fieldData}
                    showTables={showTables}
                    setReload={setReload}
                    setReload2={setReload2}
                    productData={productData}
                    setReFetchBuyerName={setReFetchBuyerName}
                    currencydata={currencydata}
                    setCurrencydata={setCurrencydata}
                    selectedcurr={selectedcurr}
                    setSelectedCurr={setSelectedCurr}
                  />
                </Col>
                <Col lg={7}>
                  <div bordered style={{ boxShadow: '0px 0px 4px -1px grey', borderRadius: '6px' }}>
                    <Row>
                      <Col lg={16}>
                        <table className="slide-table" style={{ fontSize: '12px', width: '100%' }}>
                          <tbody>
                            {/* <tr>
                              <td style={{ fontSize: '12px', width: '100px' }}>
                                <strong>Product Code</strong>
                              </td>
                              <td>
                                <strong>:</strong>
                              </td>
                              <td >{productData?.ProductCode}</td>
                            </tr> */}
                            <tr>
                              <td>
                                <strong>{attributesName?.AliasCode || 'ALias Code'}</strong>
                              </td>
                              <td>
                                <strong>:</strong>
                              </td>

                              <td>{productData?.ProductId || '-'}</td>
                            </tr>
                            <tr>
                              <td>
                                <strong>{attributesName?.ProductName || 'Product Name'}</strong>
                              </td>
                              <td>
                                <strong>:</strong>
                              </td>

                              <td>{productData?.ProductName || '-'}</td>
                            </tr>
                            <tr>
                              <td>
                                <strong>{attributesName?.finish || 'Finish'}</strong>
                              </td>
                              <td>
                                <strong>:</strong>
                              </td>

                              <td>{productData?.FinishName || '-'}</td>
                            </tr>
                            <tr>
                              <td>
                                <strong>{attributesName?.color || 'Color'}</strong>
                              </td>
                              <td>
                                <strong>:</strong>
                              </td>
                              <td>{productData?.ColorName || '-'}</td>
                            </tr>

                            <tr>
                              <td>
                                <strong>Size (Inch)</strong>
                              </td>
                              <td>
                                <strong>:</strong>
                              </td>
                              <td>
                                {SizeUnit === 'inch'
                                  ? `${Length}*${Width}*${Height} `
                                  : `${(Length / 2.54).toFixed(2)}*${(Width / 2.54).toFixed(2)}*${(
                                    Height / 2.54
                                  ).toFixed(2)}`}
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <strong>Size (cm)</strong>
                              </td>
                              <td>
                                <strong>:</strong>
                              </td>
                              <td>
                                {SizeUnit === 'cm'
                                  ? `${Length}*${Width}*${Height}`
                                  : `${(Length * 2.54).toFixed(2)}*${(Width * 2.54).toFixed(2)}*${(
                                    Height * 2.54
                                  ).toFixed(2)}`}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table className="slide-table" style={{ fontSize: '12px', width: '100%' }}>
                          <tbody>
                            <tr>
                              <td>
                                <strong>CBM/Carton</strong>
                              </td>
                              <td>
                                <strong>:</strong>
                              </td>
                              <td>{totalCBM || 0}</td>
                              <td> </td>
                              <td>
                                <strong>CMB/PC</strong>
                              </td>
                              <td>
                                <strong>:</strong>
                              </td>
                              <td>{totalCBMperpc ?? 0}</td>
                            </tr>
                            <tr>
                              <td>
                                <strong> 20 Feet</strong>
                              </td>
                              <td>
                                <strong>:</strong>
                              </td>
                              <td>{feet20 || 0}</td>
                              <td> </td>

                              <td style={{ whiteSpace: 'nowrap' }}>
                                <strong> 40hq Feet</strong>
                              </td>
                              <td>
                                <strong>:</strong>
                              </td>
                              <td>{feet40 || 0}</td>
                            </tr>
                          </tbody>
                        </table>
                      </Col>
                      <Col lg={8}>
                        <div
                          style={{
                            width: '100%',
                            height: '100px',
                            margin: 'auto',
                            borderRadius: '10px',
                            overflow: 'hidden'
                          }}
                        >
                          <img
                            src={`${globalIP}${productData?.CoverImage?.data?.attributes?.url}`}
                            alt={productData?.CoverImage?.data?.attributes?.name}
                            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                          />
                        </div>
                      </Col>

                      {/* <Col lg={24}>
                        <table className="slide-table" style={{ width: '100%' }}>
                          <tbody>
                            <tr>
                              <td style={{ fontSize: '12px' }}>
                                <strong>Size (Inch)</strong>
                              </td>
                              <td >
                                <strong>:</strong>
                              </td>
                              <td style={{ fontSize: '12px' }}>
                                {SizeUnit === 'inch'
                                  ? `${Length}*${Width}*${Height} `
                                  : `${(Length / 2.54).toFixed(2)}*${(Width / 2.54).toFixed(2)}*${(Height / 2.54).toFixed(2)}`}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ fontSize: '12px' }}>
                                <strong>Size (cm)</strong>
                              </td>
                              <td >
                                <strong>:</strong>
                              </td>
                              <td style={{ fontSize: '12px' }}>
                                {SizeUnit === 'cm'
                                  ? `${Length}*${Width}*${Height}`
                                  : `${(Length * 2.54).toFixed(2)}*${(Width * 2.54).toFixed(2)}*${(
                                    Height * 2.54
                                  ).toFixed(2)}`}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ fontSize: '12px' }}>
                                <strong>CBM/Carton</strong>
                              </td>
                              <td >
                                <strong>:</strong>
                              </td>
                              <td style={{ fontSize: '12px' }}>{totalCBM || 0}</td>
                              <td style={{ fontSize: '12px' }}>
                                <strong>CMB/PC</strong>
                              </td>
                              <td >
                                <strong>:</strong>
                              </td>
                              <td style={{ fontSize: '12px' }}>{totalCBMperpc ?? 0}</td>
                            </tr>
                            <tr>
                              <td style={{ fontSize: '12px' }}>
                                <strong> 20 Feet</strong>
                              </td>
                              <td >
                                <strong>:</strong>
                              </td>
                              <td style={{ fontSize: '12px' }}>{feet20 || 0}</td>
                       
                              <td style={{ fontSize: '12px' }}>
                                <strong> 40hq Feet</strong>
                              </td>
                              <td >
                                <strong>:</strong>
                              </td>
                              <td style={{ fontSize: '12px' }}>{feet40 || 0}</td>
                            </tr>

                          </tbody>
                        </table>
                      </Col> */}
                    </Row>
                  </div>
                </Col>
                {showTables.wood && (
                  <Col lg={24} style={{ marginBottom: '16px', marginTop: '15px' }}>
                    <Table
                      bordered
                      cellBordered
                      rowHeight={35}
                      data={costingTableData['CostingWood']}
                      autoHeight
                      height={costingTableData['CostingWood'].length ? null : 80}
                      headerHeight={80}
                    >
                      {columns1.map(({ label, key, renderCell, fixed, subColumns }) => {
                        return !subColumns ? (
                          <Column
                            fixed={fixed}
                            align="center"
                            key={label}
                            width={label == 'S.no' ? 50 : ['Unit', "Pcs", 'Rate'].includes(label) ? 80 : 100}
                            flexGrow={label == 'S.no' ? null : ['Unit', "Pcs", "Rate", "QTY",].includes(label) ? 4 : label == "Add Material" ? 5 : 6}
                          >
                            <HeaderCell
                              style={{
                                fontSize: '11px',
                                fontWeight: 'bold',
                                whiteSpace: 'break-spaces',
                                padding: label == 'Add Material' ? '10px 0 0 10px' : null,

                              }}
                            >
                              {label == 'Add Material' ? (
                                <ButtonToolbar>

                                  <Button
                                    size="sm"
                                    active
                                    style={{
                                      cursor: 'pointer',
                                      color: '#8e8e93',
                                      fontSize: '11px',
                                      margin: 'auto'
                                    }}
                                    onClick={() => handleAddRow('CostingWood')}
                                  >
                                    Add Wood
                                  </Button>
                                </ButtonToolbar>

                              ) : (
                                label
                              )}
                            </HeaderCell>
                            <Cell dataKey={key} style={{ padding: 3, margin: 0, display: 'flex', alignItems: 'center' }}>
                              {(rowData, index) =>
                                renderCell ? renderCell(rowData, index) : rowData[key]
                              }
                            </Cell>
                          </Column>
                        ) : (
                          <ColumnGroup header={label} align="center">
                            {subColumns.map(item => (
                              <Column
                                colSpan={4}
                                align="center"
                                key={item.key}
                                width={['L', 'W', 'T'].includes(item.key) ? 60 : 85}
                              >
                                <HeaderCell>{item.label}</HeaderCell>
                                <Cell dataKey={item.key} style={{ padding: 3, margin: 0, display: 'flex', alignItems: 'center' }}>
                                  {(rowData, index) =>
                                    item.renderCell
                                      ? item.renderCell(rowData, index)
                                      : rowData[item.key]
                                  }
                                </Cell>
                              </Column>
                            ))}
                          </ColumnGroup>
                        );
                      })}
                    </Table>
                  </Col>
                )}
                <Col lg={17}>
                  {showTables.process && (
                    <Table
                      bordered
                      cellBordered
                      rowHeight={35}
                      autoHeight
                      data={costingTableData['CostingProcess']}
                      height={costingTableData['CostingProcess'].length ? null : 40}
                    >
                      {columns2.map(({ label, key, renderCell, fixed }) => {
                        return (
                          <Column
                            fixed={fixed}
                            key={key}
                            flexGrow={label == 'S.no' ? null : 1}
                            width={label == 'S.no' ? 50 : null}
                            align="center"
                          >
                            <HeaderCell
                              style={{
                                fontSize: '11px',
                                fontWeight: 'bold',
                                padding: label == 'Add Material' ? '5px 0 0 2px' : null
                              }}
                            >
                              {label == 'Add Material' ? (
                                <Button
                                  size="sm"
                                  active
                                  style={{ cursor: 'pointer', color: '#8e8e93', fontSize: '11px' }}
                                  onClick={() => handleAddRow('CostingProcess')}
                                >
                                  Add Process
                                </Button>
                              ) : (
                                label
                              )}
                            </HeaderCell>
                            <Cell dataKey={key} style={{ padding: 3, margin: 0, display: 'flex', alignItems: 'center' }}>
                              {(rowData, index) =>
                                renderCell ? renderCell(rowData, index) : rowData[key]
                              }
                            </Cell>
                          </Column>
                        );
                      })}
                    </Table>
                  )}
                  <Row style={{ padding: '15px 0 0 5px ' }}>
                    {showTables.accessories && (
                      <Col xs={12} style={{ marginBottom: '15px' }}>
                        <Table
                          bordered
                          cellBordered
                          rowHeight={35}
                          autoHeight
                          data={costingTableData['CostingAccessory']}
                          height={costingTableData['CostingAccessory'].length ? null : 40}
                        >
                          {columns3.map(({ label, key, renderCell, fixed }) => {
                            return (
                              <Column
                                fixed={fixed}
                                key={key}
                                flexGrow={label == 'S.no' ? null : 1}
                                width={label == 'S.no' ? 50 : null}
                              >
                                <HeaderCell
                                  style={{
                                    fontSize: '11px',
                                    fontWeight: 'bold',
                                    padding: label == 'Add Accessories' ? '5px 0 0 5px' : null
                                  }}
                                  align="center"
                                >
                                  {label == 'Add Accessories' ? (
                                    <Button
                                      size="sm"
                                      active
                                      style={{
                                        cursor: 'pointer',
                                        color: '#8e8e93',
                                        fontSize: '11px'
                                      }}
                                      onClick={() => handleAddRow('CostingAccessory')}
                                    >
                                      Add Accessories
                                    </Button>
                                  ) : (
                                    label
                                  )}
                                </HeaderCell>
                                <Cell dataKey={key} style={{ padding: 3, margin: 0, display: 'flex', alignItems: 'center' }}>
                                  {(rowData, index) =>
                                    renderCell ? renderCell(rowData, index) : rowData[key]
                                  }
                                </Cell>
                              </Column>
                            );
                          })}
                        </Table>
                      </Col>
                    )}
                    {showTables.packing && (
                      <Col xs={12} style={{ marginBottom: '15px' }}>
                        <Table
                          bordered
                          cellBordered
                          rowHeight={35}
                          autoHeight
                          data={costingTableData['Costingpacking']}
                          height={costingTableData['Costingpacking'].length ? null : 40}
                        >
                          {columns4.map(({ label, key, renderCell, fixed }) => {
                            return (
                              <Column
                                fixed={fixed}
                                key={key}
                                flexGrow={label == 'S.no' ? null : 1}
                                width={label == 'S.no' ? 50 : null}
                              >
                                <HeaderCell
                                  style={{
                                    fontSize: '11px',
                                    fontWeight: 'bold',
                                    padding: label == 'Add Packing' ? '5px 0 0 5px' : null
                                  }}
                                  align="center"
                                >
                                  {label == 'Add Packing' ? (
                                    <Button
                                      size="sm"
                                      active
                                      style={{
                                        cursor: 'pointer',
                                        color: '#8e8e93',
                                        fontSize: '11px'
                                      }}
                                      onClick={() => handleAddRow('Costingpacking')}
                                    >
                                      Add Packing
                                    </Button>
                                  ) : (
                                    label
                                  )}
                                </HeaderCell>
                                <Cell dataKey={key} style={{ padding: 3, margin: 0, display: 'flex', alignItems: 'center' }}>
                                  {(rowData, index) =>
                                    renderCell ? renderCell(rowData, index) : rowData[key]
                                  }
                                </Cell>
                              </Column>
                            );
                          })}
                        </Table>
                      </Col>
                    )}
                    <BottomLeftSection
                      updatingCalc={updatingCalc}
                      handleFieldDataValue={handleFieldDataValue}
                      fieldData={fieldData}
                      setReload={setReload}
                      setReload2={setReload2}
                      showTables={showTables}
                      setCostingheads={setCostingheads}
                      costingheads={costingheads}
                      handleReload={handleReload}
                      handleFieldUpdate={handleFieldUpdate}
                    />
                  </Row>
                </Col>
                <Col lg={7}>
                  <PackingSection
                    setCartoonSize={setCartoonSize}
                    cartoonSize={cartoonSize}
                    label={label}

                    productData={productData}
                    setFeet40={setFeet40}
                    setFeet20={setFeet20}
                    setTotalCBM={setTotalCBM}
                    setTotalCBMperpc={setTotalCBMperpc}
                    fieldData={fieldData}
                    setFieldData={setFieldData}
                    showTables={showTables}
                    setReload={setReload}
                    setReload2={setReload2}
                    handleFieldDataValue={handleFieldDataValue}
                    state={state}
                    packaging={packaging}
                    setPackaging={setPackaging}
                    setTotalMasterPC={setTotalMasterPC}
                    totalMasterPC={totalMasterPC}
                    setTotalInnerPc={setTotalInnerPc}
                    totalInnerPc={totalInnerPc}
                    handleReload={handleReload}
                    handleFieldUpdate={handleFieldUpdate}
                    updatingCalc={updatingCalc}
                    selectedcurr={selectedcurr}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Grid>
      </main>
      <SuccessModal setOpen={setOpen} open={open} />
      <ResetModal reset={reset} setReset={setReset} handleReset={handleReset} />
    </>
  );
}

export const ControlRow = ({
  label,
  control,
  ...rest
}: {
  label?: string | ReactElement;
  control?: ReactElement;
} & React.HTMLAttributes<HTMLDivElement>) => (
  <FlexboxGrid {...rest} align="middle">
    <FlexboxGrid.Item colspan={8} style={{ fontSize: '14px' }}>
      {label}:{' '}
    </FlexboxGrid.Item>
    <FlexboxGrid.Item colspan={16}>{control}</FlexboxGrid.Item>
  </FlexboxGrid>
);
export const ControlRow2 = ({
  label,
  control,
  ...rest
}: {
  label?: string | ReactElement;
  control?: ReactElement;
} & React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <FlexboxGrid {...rest} align="middle">
      <FlexboxGrid.Item colspan={6} style={{ fontSize: '14px' }}>
        {label}:{' '}
      </FlexboxGrid.Item>
      <FlexboxGrid.Item colspan={18}>{control}</FlexboxGrid.Item>
    </FlexboxGrid>
  );
};
export const ThreeControlRow = ({ label, control, control2, ...rest }) => (
  <FlexboxGrid {...rest} align="middle" justify="space-around">
    <FlexboxGrid.Item colspan={6} style={{ fontSize: '14px' }}>
      {label}:{' '}
    </FlexboxGrid.Item>
    <FlexboxGrid.Item colspan={9}>{control}</FlexboxGrid.Item>
    <FlexboxGrid.Item colspan={8}>{control2}</FlexboxGrid.Item>
  </FlexboxGrid>
);
export const ControlCol = ({ label, control, ...rest }) => (
  <FlexboxGrid {...rest} align="middle">
    <FlexboxGrid.Item colspan={24} style={{ fontSize: '14px' }}>
      {label}:{' '}
    </FlexboxGrid.Item>
    <FlexboxGrid.Item colspan={24}>{control}</FlexboxGrid.Item>
  </FlexboxGrid>
);
interface CustomInput {
  size?: any;
  placeholder?: string;
  value?: string;
  onChange?: (value: any) => void;
  name?: string;
  readOnly?: boolean;
  disabled?: boolean;
  type?: string;
  defaultValue?: string;
}
export const CustomInput = ({ size, ...props }: CustomInput) => {
  return <InputNumber {...props} size={size || 'xs'} />;
};

const SuccessModal = ({ open, setOpen }) => {
  const navigate = useNavigate();
  return (
    <Modal open={open} onClose={() => setOpen(false)} backdrop="static">
      <Modal.Body>
        <Stack direction="column">
          <Icon
            as={CheckOutlineIcon}
            color="cyan"
            style={{ fontSize: '100px', marginBottom: '20px' }}
          />
          <b>Saved Successfully</b>
        </Stack>
      </Modal.Body>
      <Modal.Footer>
        <Button
          appearance="primary"
          color="cyan"
          onClick={() => {
            setOpen(false);
            navigate(`/${ugr}/product-Selection-Page`);
          }}
        >
          Ok
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
const ResetModal = ({ reset, setReset, handleReset }) => {
  const navigate = useNavigate();
  return (
    <Modal open={reset} size="xs" onClose={() => setReset(false)}>
      <Modal.Body>
        <Stack direction="column">

          <b>Are you sure you want to Delete?</b>
        </Stack>
      </Modal.Body>
      <Modal.Footer>
        <Button
          appearance="primary"
          color="cyan"
          onClick={() => {
            handleReset()
          }}
        >
          Yes
        </Button>
        <Button
          appearance="primary"
          color="cyan"
          onClick={() => {
            setReset(false)

          }}
        >
          No
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
